<template>
  <div>
    <transition name="fade">
      <div class="mask" v-show="display" @click="hide"></div>
    </transition>
    <transition name="slide">
      <div class="picker" v-show="display">
      <div class="picker-title">
        <div class="close" @click="cancel" ></div>
        <!-- <span class="pt-cancel" @click="cancel" :style="{ color: colorCancel }">{{textCancel}}</span> -->
        <!-- <span class="pt-submit" @click="confirm" :style="{ color: colorConfirm }">{{textConfirm}}</span> -->
        <div class="dateTime"  @click="todo">{{textTitle}}</div>
      </div>
      <div class="picker-panel">
        <div class="picker-mask-top"></div>
        <div class="picker-mask-bottom"></div>
        <div class="picker-wheel-wrapper" ref="wheelWrapper">
          <div v-for="(wheel, index) in pickerData" :key="index" class="picker-wheel" >
            <ul class="wheel-scroll">
              <li class="wheel-item" v-for="(item, index) in wheel" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="success" @click="confirm">完成</div>
    </div>
    </transition>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import { dateData, dateAnchor } from './data/date.js'

const DATA_NORMAL = 'normal'
const DATA_CASCADE = 'cascade'

const TYPE_NORMAL = 'normal'
const TYPE_TIME = 'time'
const TYPE_DATE = 'date'

const TEXT_TITLE = ''
const TEXT_CONFIRM = '确定'
const TEXT_CANCEL = '取消'

const COLOR_TITLE = '#000000'
const COLOR_CONFIRM = '#42b983'
const COLOR_CANCEL = '#999999'

const EVENT_TODO = 'todo'
const EVENT_CONFIRM = 'confirm'
const EVENT_CANCEL = 'cancel'

export default {
  name: 'awesome-picker',
  props: {
    data: {    
      type: Array,
      default () {
        return []
      }
    },
    anchor: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: TYPE_NORMAL
    },
    textTitle: {
      type: String,
      default: TEXT_TITLE
    },
    textConfirm: {
      type: String,
      default: TEXT_CONFIRM
    },
    textCancel: {
      type: String,
      default: TEXT_CANCEL
    },
    colorTitle: {
      type: String,
      default: COLOR_TITLE
    },
    colorConfirm: {
      type: String,
      default: COLOR_CONFIRM
    },
    colorCancel: {
      type: String,
      default: COLOR_CANCEL
    },
    swipeTime: {
      type: Number,
      default: 1800
    }
  },
  data () {
    return {
      dateTime:false,
      display: false,
      dataChange: false,
      pickerData: this._dataGetter(),
      pickerAnchor: this._anchorGetter(),
      wheels: []
    }
  },
  watch: {
    data () {
      this._setPickerData()
    }
  },
  computed: {
    proxyData () {
      return this._dataGetter()
    },
    proxyAnchor () {
      return this._anchorGetter()
    },
    dataType () {
      return !Array.isArray(this.proxyData[0]) ? DATA_CASCADE : DATA_NORMAL
    }
  },
  methods: {
    todo(){
        this.dateTime=!this.dateTime;
      this.$emit(EVENT_TODO, this.dateTime)
      // this.hide()
       // this.$emit('func',this.dateTime)
        // if(this.dateTime){
        //      this.$refs.picker0.show()
        // }else{
        //      this.$refs.picker.show()
        // }
    },
    _dataGetter () {
      let data = null
      switch (this.type) {
        case TYPE_TIME:
          data = timeData; break
        case TYPE_DATE:
          data = dateData; break
        case TYPE_NORMAL:
        default:
          data = this.data; break
      }
      return [...data]
    },

    _anchorGetter () {
      let anchor = []
      if (this.anchor.length) {
        anchor = this.anchor
      } else {
        switch (this.type) {
          case TYPE_DATE:
            anchor = dateAnchor; break
          default:
            anchor = this.anchor; break
        }
      }

      anchor = anchor.map((item, i) => {
        let index = 0
        if (item.index) {
          index = item.index
        } else if (item.value) {
          index = this.pickerData && this.pickerData[i] && this.pickerData[i].indexOf(item.value) > -1
            ? this.pickerData[i].indexOf(item.value) : 0
        } else {
          index = item
        }
        return index
      })
      return [...anchor]
    },

    show () {
      this.display = true
      if (!this.wheels.length || this.dataChange) {
        this.dataType === DATA_CASCADE && this._updatePickerData()
        this.$nextTick(() => {
          const wheelWrapper = this.$refs.wheelWrapper
          this.pickerData.forEach((item, index) => {
            this._createWheel(wheelWrapper, index).enable()
          })
          this._wheelToAnchor(this.proxyAnchor)

          this.dataChange && this._destroyExtraWheels()
          this.dataChange = false
        })
      } else {
        this.wheels.forEach((wheel) => {
          wheel.enable()
        })
      }
    },

    hide () {
      this.wheels.forEach((wheel) => {
        wheel.disable()
      })
      this.display = false
    },

    _createWheel (wheelWrapper, i) {
      if (!this.wheels[i]) {
        const wheel = this.wheels[i] = new BScroll(wheelWrapper.children[i], {
          wheel: {
            selectedIndex: 0,
            rotate: 25
          },
          swipeTime: this.swipeTime
        })
        wheel.on('scrollEnd', () => {
          this._cascadePickerChange(i)
        })
      } else {
        this.wheels[i].refresh()
      }
      return this.wheels[i]
    },

    _cascadePickerChange (i) {
      if (this.dataType !== DATA_CASCADE) {
        return
      }
      const newIndex = this._getCurrentValue()[i].index
      if (newIndex !== this.pickerAnchor[i]) {
        this.pickerAnchor.splice(i, 1, newIndex)
        this._updatePickerData(i + 1)
      }
    },

    _wheelToAnchor (data) {
      this.wheels.forEach((wheel, i) => {
        wheel.wheelTo(data[i] || 0)
      })
    },

    _getCurrentValue () {
      const value = []
      this.wheels.forEach((wheel, i) => {
        const j = wheel.getSelectedIndex()
        value.push({
          index: j,
          value: this.pickerData[i][j]
        })
      })
      return value
    },

    _setPickerData () {
      this.pickerData = this._dataGetter()
      this.pickerAnchor = this._anchorGetter()
      if (this.display) {
        this.$nextTick(() => {
          const wheelWrapper = this.$refs.wheelWrapper
          this.pickerData.forEach((item, i) => {
            this._createWheel(wheelWrapper, i)
          })
          this._wheelToAnchor(this.proxyAnchor)
          this._destroyExtraWheels()
        })
      } else {
        this.dataChange = true
      }
    },

    _destroyExtraWheels () {
      const dataLength = this.pickerData.length
      if (dataLength < this.wheels.length) {
        const extraWheels = this.wheels.splice(dataLength)
        extraWheels.forEach((wheel) => {
          wheel.destroy()
        })
      }
    },

    _updatePickerData (wheelIndex = 0) {
      let data = [...this.proxyData]
      let i = 0
      while (data) {
        if (i >= wheelIndex) {
          let wheelData = []
          data.forEach((item) => {
            wheelData.push(item.value)
          })
          this.pickerData[i] = wheelData
          this.pickerAnchor[i] = wheelIndex === 0
            ? (this.pickerAnchor[i] < data.length ? this.pickerAnchor[i] || 0 : 0)
            : this._reloadWheel(i, wheelData)
        }
        data = data.length ? data[this.pickerAnchor[i]].children : null
        i++
      }
      this.pickerData = this.pickerData.slice(0, i)
    },

    _reloadWheel (index, data) {
      const wheelWrapper = this.$refs.wheelWrapper
      let scroll = wheelWrapper.children[index].querySelector('.wheel-scroll')
      let wheel = this.wheels ? this.wheels[index] : false
      let dist = 0
      if (scroll && wheel) {
        this.$set(this.pickerData, index, data)
        this.pickerAnchor[index] = dist
        this.$nextTick(() => {
          wheel = this._createWheel(wheelWrapper, index)
          wheel.wheelTo(dist)
        })
      }
      return dist
    },

    confirm () {
      const isInTransition = this.wheels.some((wheel) => {
        return wheel.isInTransition
      })
      if (isInTransition) {
        return
      }
      const selectedValues = this._getCurrentValue()
      this.$emit(EVENT_CONFIRM, selectedValues)
      this.hide()
    },

    cancel () {
      this.$emit(EVENT_CANCEL)
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
  /* fade */
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .3s ease;
  }

  /* slide */
  .slide-enter, .slide-leave-to {
    opacity: 0.5;
    transform: translate3d(0, 540px, 0)
  }

  .slide-enter-active, .slide-leave-active {
    transition: all .3s ease;
  }
  .month{width:200px;height:56px;background:url('/static/images/month.png') no-repeat center center;background-size:100% 100%;position: absolute;top:48px;left:26px;}
  .date{width:200px;height:56px;background:url('/static/images/date.png') no-repeat center center;background-size:100% 100%;position: absolute;top:48px;left:26px;}
  .dateTime{width:176px*2;height:56px*2;line-height:56px*2;color:#333334;padding-left:24px*2;font-size:28px*2;border-radius:28px*2;background:#D8D8D8 url('/static/images/cut.png') no-repeat center right 28px*2;background-size:28px*2 28px*2;position: absolute;top:48px;left:26px*2; transform: scale(0.5); transform-origin: 0% 0%;}
  .close{width:48px;height:48px;background:url('/static/images/close.png') no-repeat center center;background-size:100% 100%;position: absolute;top:56px;right:28px;}
  .success{width:100%;line-height:120px;font-size:28px;color: #9B9B9B;border-top:2px solid #F2F2F2;text-align: center;}
  .pt-play{
    width:50%;
  }
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0,0,0,.2);
  }

  .picker {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 660px;
    z-index: 10000;
    background: #fff;
    border-radius:40px 40px 0 0;
  }

  .picker-title {
    position: relative;
    height: 88px;
    color: #333;

    &:after {
      content: '';
      display: block;
      left: 0;
      right: 0;
      transform: scaleY(.5);
    }

    span {
      position: absolute;
      height: 88px;
      line-height: 88px;
      padding: 0 24px;
      font-size: 28px;
    }

    .pt-cancel {
      left: 0;
      color: #999;
    }

    .pt-submit {
      right: 0;
      color: #42b983;
    }

    h4 {
      margin: 0;
      font-size: 32px;
      font-weight: normal;
      height: 88px;
      line-height: 88px;
      text-align: center;
    }
  }

  .picker-panel {
    position: relative;
    height: 452px;
    padding: 48px 24px;
    box-sizing: border-box;

    .picker-mask-top, .picker-mask-bottom {
      position: absolute;
      left: 0;
      right: 0;
      height: 144px;
      background: #fff;
      transform: translateZ(0);
      z-index: 1;
      pointer-events: none;
    }

    .picker-mask-top {
      top: 48px;
      background: linear-gradient(to bottom, rgba(255,255,255,.9), rgba(255,255,255,.5));

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 2px solid #ebebeb;
        transform: scaleY(.5);
      }
    }

    .picker-mask-bottom {
      bottom: 48px;
      background: linear-gradient(to top, rgba(255,255,255,.9), rgba(255,255,255,.5));

      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        border-bottom: 2px solid #ebebeb;
        transform: scaleY(.5);
      }
    }
  }

  .picker-wheel-wrapper {
    display: flex;
    align-items: stretch;
    height: 100%;
    overflow:hidden;
    .picker-wheel {
      flex: 1;
      overflow: hidden;
    }

    .wheel-scroll {
      margin-top: 144px;

      .wheel-item {
        height: 68px;
        line-height: 68px;
        font-size: 34px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/person/vue-awesome-picker.vue